import { Route } from "@angular/router";
import { AuthGuard, LoginGuard, LoginMatchGuard, resolveModuleTranslations } from "core";
import { provideTranslocoScope } from '@jsverse/transloco';
import { BaseLayoutComponent } from "../components/base-layout/base-layout";

export const baseRoutes: Route[] = [
    { path: '', pathMatch: 'full', redirectTo: 'login' },
    {
        path: 'login',
        canActivate: [LoginGuard],
        canMatch: [LoginMatchGuard],
        loadComponent: () => import('../pages/login/login').then(m => m.Login)
    },
    { path: 'auth/callback', loadComponent: () => import('../pages/auth-callback/auth-callback').then(m => m.AuthCallback) },
	// { path: 'recover-password', loadComponent: () => import('../pages/recover-password/recover-password').then(m => m.RecoverPassword) }
];

export const baseAuthenticatedRoute: Route = {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: BaseLayoutComponent,
    children: [
        { path: 'dashboard', loadComponent: () => import('../pages/dashboard/dashboard').then(m => m.Dashboard) },
        { path: 'profile', loadComponent: () => import('../pages/profile/profile').then(m => m.Profile) },
        { path: 'test', loadComponent: () => import('test').then(m => m.AccessibilityTestpage) },
        { path: 'test-transloco', loadComponent: () => import('test').then(m => m.TestPage) },
        { path: 'orders/list', loadComponent: () => import('orders').then(m => m.OrdersList) },
        { path: 'order-detail', loadComponent: () => import('orders').then(m => m.OrderDetail) },
        { path: 'new-order-proposal', loadComponent: () => import('orders').then(m => m.NewOrderProposal) },
        { path: 'new-order-proposal/select-customer', loadComponent: () => import('orders').then(m => m.SelectCustomer) },
        { path: 'new-order-proposal/new-customer', loadComponent: () => import('orders').then(m => m.NewCustomer) },
        { path: 'new-order-proposal/create-customer', loadComponent: () => import('orders').then(m => m.CreateCustomer) },
        { path: 'new-order-proposal/configure-customer/zones', loadComponent: () => import('orders').then(m => m.ConfigureCustomerZones) },
        { path: 'new-order-proposal/configure-customer/contacts', loadComponent: () => import('orders').then(m => m.ConfigureCustomerContacts) },
        { path: 'new-order-proposal/configure-customer/banking', loadComponent: () => import('orders').then(m => m.ConfigureCustomerBanking) },
        { path: 'new-order-proposal/configure-customer/order-notes', loadComponent: () => import('orders').then(m => m.ConfigureCustomerOrderNotes) },
        { path: 'new-order-proposal/configure-customer/gdpr', loadComponent: () => import('orders').then(m => m.ConfigureCustomerGdpr) },
        { path: 'new-order-proposal/configure-customer', loadComponent: () => import('orders').then(m => m.ConfigureCustomer) },
        { path: 'new-order-proposal/select-products', loadComponent: () => import('orders').then(m => m.SelectProducts) },
        { path: 'new-order-proposal/shipping-payment', loadComponent: () => import('orders').then(m => m.ShippingPayment) },
        { path: 'new-order-proposal/select-destination', loadComponent: () => import('orders').then(m => m.SelectDestination) },
        { path: 'new-order-proposal/select-payment', loadComponent: () => import('orders').then(m => m.SelectPayment) },
        { path: 'new-order-proposal/summary', loadComponent: () => import('orders').then(m => m.OrderSummary) },
    ].map((route: Route) => {
        const scope = route.path?.startsWith('test') ? 'test'
            : route.path === 'orders/list' || route.path === 'order-detail' || route.path?.startsWith('new-order-proposal') ? 'orders'
            : undefined;
        return scope ? {
            ...route,
            providers: [provideTranslocoScope(scope)],
            resolve: { translations: resolveModuleTranslations(scope) },
        } : route;
    })
};

// Ultima nella lista di route (wildcard)
export const defaultRoute: Route = {
    path: '**', pathMatch: 'full', redirectTo: 'dashboard'
};
